// components/inputTheme.js
const InputTheme = {
  parts: ["field"],

  variants: {
    outline: {
      field: {
        fontFamily: "'Inter', sans-serif",
        fontSize: "14px",
        lineHeight: "24px",
        color: "#222222",
        bg: "#F3F3F5",
        border: "1px solid #E6E8EE",
        borderRadius: "10px",
        px: "12px",
        h: "36px",
        transition: "all 0.2s ease",

        _placeholder: { color: "#999999" },
        _hover: { borderColor: "#666666" },
        _focus: {
          // borderColor: "#FF6600",
          // boxShadow: "0 0 0 1px #FF6600",
          borderColor: "#666666",
          boxShadow: "0 0 0 1px #666666",
        },
      },
    },
  },

  defaultProps: {
    size: "sm",
    variant: "outline",
  },
};

export default InputTheme;
